import React from "react";
import "./eventCards.css";
import { Link } from "react-router-dom";

// Utility function to strip HTML tags and get plain text
const stripHtmlTags = (html) => {
  if (!html) return "";
  // Replace HTML tags with spaces to preserve spacing between text nodes
  const textWithSpaces = html.replace(/<[^>]*>/g, ' ');
  // Create a temporary div element to decode HTML entities and get clean text
  const tmp = document.createElement("DIV");
  tmp.innerHTML = textWithSpaces;
  const text = tmp.textContent || tmp.innerText || "";
  // Normalize whitespace: replace multiple spaces/newlines with single space, then trim
  return text.replace(/\s+/g, ' ').trim();
};

// Utility function to truncate text
const truncateText = (text, maxLength = 120) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + "...";
};

const EventCards = ({ imageUrl, title, date, location, description, eventUrl }) => {
  // Strip HTML tags and truncate description for card preview
  const plainTextDescription = truncateText(stripHtmlTags(description));
  
  return (
    <Link to={eventUrl} className="event-card-link">
    <div className="event-card mx-1">
    <div className="event-card__image-wrapper">
      <img src={imageUrl} alt={title} className="event-card__image" />
    </div>
      <div className="event-card__details">
        <h3>{title}</h3>
        <p className="event-card__description">{plainTextDescription}</p>
      </div>
    </div>
  </Link>
  );
};

export default EventCards;
